let hasAdminRoles = roles => roles.includes('ADMIN_USER') || roles.includes('STANDARD_USER')
import appConfig from '@/config/applicationConfig.js'

const VentasItems = (roles) => {
  const ORDER_LIST_ITEM = {
    name: 'Ordenes',
    url: '/orders/list',
    icon: 'fa fa-shopping-bag'
  }
  const ORDER_CSV_PUNISHMNETS_ITEM = {
    name: 'Penalizaciones CSV',
    url: '/orders/addPunishmentCSV',
    icon: 'fa fa-list-alt'
  }
  const ORDER_CSV_LIQUIDATIONS_ITEM = {
    name: 'Liquidaciones CSV',
    url: '/orders/addLiquidationsCSV',
    icon: 'fa fa-list-alt'
  }
  const TAXES_ITEM = {
    name: 'Impuestos',
    url: '/orders/taxes',
    icon: 'fa fa-list-alt'
  }
  const SUBSTATUS = {
    name: 'Sub-estados',
    url: '/orders/substatus',
    icon: 'fa fa-list-alt'
  }

  let result = [ORDER_LIST_ITEM]

  if (hasAdminRoles(roles) && !appConfig.HIDE_PENALIZACIONES_LIQUIDACIONES) {
    result.push(ORDER_CSV_PUNISHMNETS_ITEM)
    result.push(ORDER_CSV_LIQUIDATIONS_ITEM)
  }
  if (hasAdminRoles(roles) && (appConfig.HIDE_IMPUESTOS === 'false' || appConfig.HIDE_IMPUESTOS === false)) {
    result.push(TAXES_ITEM)
  }
  if (hasAdminRoles(roles) || roles.includes('LOGISTICS_ADMIN')) {
    result.push(SUBSTATUS)
  }

  return result
}

const CatalogItems = roles => {
  const PRODUCT_MANAGEMENT_ITEM = {
    name: 'Administrar Productos',
    url: '/catalog/list',
    icon: 'fa fa-list-alt'
  }
  const PRODUCT_CREATION_ITEM = {
    name: 'Alta manual de Productos',
    url: '/catalog/new',
    icon: 'fa fa-list-alt'
  }
  const MASIVE_PRODUCT_CREATION_ITEM = {
    name: 'Alta masiva de Productos',
    url: '/catalog/addProductsCSV',
    icon: 'fa fa-list-alt'
  }
  const MASIVE_UPDATE_PRICES_ITEM = {
    name: 'Actualización masiva de Precios',
    url: '/catalog/changePricesCSV',
    icon: 'fa fa-list-alt'
  }
  const INVENTORY_LIST_ITEM = {
    name: 'Administrar Inventario',
    url: '/catalog/inventory/list',
    icon: 'fa fa-list-alt'
  }
  const PROMOTIONS = {
    name: 'Promociones',
    url: '/catalog/promotions',
    icon: 'fa fa-tags'
  }

  let response = [PRODUCT_MANAGEMENT_ITEM]

  if (roles.includes('LOGISTICS_ADMIN') && roles.includes('CATALOG_USER')) {
    return [PRODUCT_MANAGEMENT_ITEM]
  }
  if (!hasAdminRoles(roles) && (roles.includes('INVENTORY_USER') || roles.includes('CATALOGER_USER'))) {
    response = response.concat([PRODUCT_CREATION_ITEM, MASIVE_PRODUCT_CREATION_ITEM, MASIVE_UPDATE_PRICES_ITEM, INVENTORY_LIST_ITEM, PROMOTIONS])
  } else if (!hasAdminRoles(roles)) {
    response = response.concat([PRODUCT_CREATION_ITEM, MASIVE_PRODUCT_CREATION_ITEM, MASIVE_UPDATE_PRICES_ITEM, PROMOTIONS])
  } else {
    response = response.concat([PROMOTIONS])
  }
  return response
}

const AdminItems = roles => {
  const USER_LIST_ITEM = {
    name: 'Usuarios',
    url: '/admin/users',
    icon: 'fa fa-list-alt'
  }
  const SELLER_LIST_ITEM = {
    name: 'Sellers',
    url: '/admin/sellers',
    icon: 'fa fa-list-alt'
  }
  const INTEGRATIONS_ITEM = {
    name: 'Integraciones',
    url: '/admin/integrations',
    icon: 'fa fa-list-alt'
  }
  let response = [USER_LIST_ITEM]
  if (roles.includes('ADMIN_USER')) {
    response = response.concat([SELLER_LIST_ITEM])
    if (appConfig.HIDE_INTEGRACIONES === 'false') {
      response = response.concat([INTEGRATIONS_ITEM])
    }
  }

  return response
}

const CarrierItems = roles => {
  const CARRIER_LIST_ITEM = {
    name: 'Transportadoras',
    url: '/carriers/carrierList',
    icon: 'fa fa-list-alt'
  }
  const PRICE_LIST_ITEM = {
    name: 'Precios',
    url: '/carriers/priceList',
    icon: 'fa fa-list-alt'
  }
  const MASIVE_PRICE_LIST_ITEM = {
    name: 'Alta masiva de Precios de Transportadoras',
    url: '/carriers/addPricesCSV',
    icon: 'fa fa-list-alt'
  }
  const PICKUP_POINTS = {
    name: 'Puntos de retiro',
    url: '/carriers/pickupPoints',
    icon: 'fa fa-list-alt'
  }
  let response = [CARRIER_LIST_ITEM, PRICE_LIST_ITEM, MASIVE_PRICE_LIST_ITEM]
  if (roles.includes('ADMIN_USER')) {
    response = response.concat([PICKUP_POINTS])
  }
  return response
}

const UpdateItems = roles => {
  const BRAND_CATEOGIES_ITEM = {
    name: 'Catalogo y Marcas',
    url: '/updates/catalogAndBrand',
    icon: 'fa fa-list-alt'
  }
  const CATALOG_ITEM = {
    name: 'Catálogo Siman',
    url: '/updates/cataloging',
    icon: 'fa fa-list-alt'
  }
  const ATTRIBUTES_ITEM = {
    name: 'Atributos',
    url: '/updates/attributes',
    icon: 'fa fa-list-alt'
  }
  return [BRAND_CATEOGIES_ITEM, CATALOG_ITEM, ATTRIBUTES_ITEM]
}

export default {
  items: roles => {
    const DASHBOARD_NAV = {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-tachometer-alt'
    }
    const ORDERS_NAV = {
      name: 'Ventas',
      url: '/orders/',
      icon: 'fa fa-shopping-bag',
      children: VentasItems(roles)
    }
    const CATALOG_NAV = {
      name: 'Catálogo',
      url: '/catalog',
      icon: 'fa fa-list-alt',
      children: CatalogItems(roles)
    }
    const REPORTS_NAV = {
      name: 'Reportes',
      url: '/reports',
      icon: 'fa fa-list-alt'
    }
    const INCIDENTS_NAV = {
      name: 'Incidencias',
      url: '/incidents',
      icon: 'fa fa-bug'
    }
    const USERS_NAV = {
      name: 'Administración',
      url: '/admin',
      icon: 'fa fa-list-alt',
      children: AdminItems(roles)
    }
    const CARRIERS_NAV = {
      name: 'Gestión de envíos',
      url: '/carriers',
      icon: 'fa fa-list-alt',
      children: CarrierItems(roles)
    }
    const UPDATES = {
      name: 'Actualizaciónes',
      url: '/updates',
      icon: 'fa fa-list-alt',
      children: UpdateItems(roles)
    }

    let result = [DASHBOARD_NAV]
    if (roles.includes('ORDERS_USER')) result.push(ORDERS_NAV)
    if (roles.includes('CATALOG_USER')) result.push(CATALOG_NAV)
    if (roles.includes('CATALOGER_USER')) result = [CATALOG_NAV]
    if (roles.includes('CARRIERS_USER')) result.push(CARRIERS_NAV)
    if (roles.includes('REPORTS_USER')) result.push(REPORTS_NAV)
    if (roles.includes('ORDERS_USER') && roles.includes('CATALOG_USER')) result.push(INCIDENTS_NAV)
    if (roles.includes('ADMIN_USER') || roles.includes('ORGANIZATION_ADMIN_USER')) result.push(USERS_NAV)
    if (roles.includes('ADMIN_USER')) result.push(UPDATES)

    return result
  }
}
